import { Section } from "@components/ui/Section";
import styles from "./page.module.css";
import { Heading } from "@components/ui/Heading";
import { IconFileTypePdf } from "@tabler/icons-react";

const sellerPolicyLinks = [
  {
    href: "https://assets.mydeal.com.au/content/marketplace/Woolworths%20MarketPlus%20Seller%20Service%20Level%20Agreement%20Policies%20(SLAs).pdf",
    text: "Woolworths MarketPlus Seller Service Level Agreement Policies (SLAs)",
  },
  {
    href: "https://assets.mydeal.com.au/content/marketplace/News%20and%20announcements%20-%20Platform%20Policies%20updates%20(effective%208%20September%202026).pdf",
    text: "News and announcements: Platform Policies updates (effective 8 September 2026)",
  },
  {
    href: "https://assets.mydeal.com.au/content/marketplace/BIG%20W%20Open%20Box%20Damaged%20Box%20Seller%20Policy.pdf",
    text: "BIG W Open Box / Damaged Box Seller Policy",
  },
  {
    href: "https://assets.mydeal.com.au/content/marketplace/Pricing%20Claims%20&%20Listing%20Representation%20Policy.pdf",
    text: "Pricing Claims & Listing Representation Policy",
  },
  {
    href: "https://assets.mydeal.com.au/content/marketplace/Important%20Update%20-%20GST%20Exempt%20Products.pdf",
    text: "Important Update: GST Exempt Products",
  },
  {
    href: "https://assets.mydeal.com.au/content/marketplace/Woolworths%20MarketPlus%20Change%20of%20Mind%20Return%20Guide.pdf",
    text: "Woolworths MarketPlus Change of Mind Return Guide",
  },
  {
    href: "https://assets.mydeal.com.au/content/marketplace/BIG%20W%20Refurbished%20Program%20Seller%20Policy.pdf",
    text: "BIG W Refurbished Program Seller Policy",
  },
  {
    href: "https://assets.mydeal.com.au/content/marketplace/Insurance%20Requirements%20Policy.pdf",
    text: "Insurance Requirements Policy",
  },
  {
    href: "https://assets.mydeal.com.au/content/marketplace/Responsible%20Sourcing%20Guidelines.pdf",
    text: "Responsible Sourcing Guidelines",
  },
  {
    href: "https://assets.mydeal.com.au/content/marketplace/Product%20Repairs%20&%20Customer%20Resolution.pdf",
    text: "Product Repairs & Customer Resolution",
  },
  {
    href: "https://assets.mydeal.com.au/content/marketplace/Third%20Party%20Intellectual%20Property%20Rights%20Policy%20and%20Complaints%20Handling%20Process.pdf",
    text: "Third Party Intellectual Property Rights Policy and Complaints Handling Process",
  },
  {
    href: "https://assets.mydeal.com.au/content/marketplace/Mandatory%20Injury%20Reporting%20Policy.pdf",
    text: "Mandatory Injury Reporting Policy",
  },
  {
    href: "https://assets.mydeal.com.au/content/marketplace/Explicit%20Sexual%20&%20Nudity%20Content%20Policy.pdf",
    text: "Explicit Sexual & Nudity Content Policy",
  },
  {
    href: "https://assets.mydeal.com.au/content/marketplace/Woolworths%20MarketPlus%20Fair%20Pricing%20Policy.pdf",
    text: "Woolworths MarketPlus Fair Pricing Policy",
  },
  {
    href: "https://assets.mydeal.com.au/content/marketplace/Returns%20and%20Refunds%20Policy.pdf",
    text: "Returns and Refunds Policy",
  },
  {
    href: "https://assets.mydeal.com.au/content/marketplace/Price%20Comparison%20Policy.pdf",
    text: "Price Comparison Policy",
  },
  {
    href: "https://assets.mydeal.com.au/content/marketplace/Knives%20Alcohol%20and%20Age%20Restricted%20Products%20Policy.pdf",
    text: "Knives, Alcohol and Age Restricted Products Policy",
  },
  {
    href: "https://assets.mydeal.com.au/content/marketplace/Banned%20Products%20Policy.pdf",
    text: "Banned Products Policy",
  },
  {
    href: "https://assets.mydeal.com.au/content/marketplace/Statement%20on%20acceptable%20use%20and%20dealing.pdf",
    text: "Statement on acceptable use and dealing",
  },
  {
    href: "https://assets.mydeal.com.au/content/marketplace/Product%20Safety%20&%20Recalls%20Policy.pdf",
    text: "Product Safety & Recalls Policy",
  },
  {
    href: "https://assets.mydeal.com.au/content/marketplace/Product%20Listing%20Policy.pdf",
    text: "Product Listing Policy",
  },
  {
    href: "https://assets.mydeal.com.au/content/marketplace/Product%20&%20Seller%20Eligibility%20Criteria.pdf",
    text: "Product & Seller Eligibility Criteria",
  },
  {
    href: "https://assets.mydeal.com.au/content/marketplace/Woolworths%20MarketPlus%20Seller%20Service%20Standards.pdf",
    text: "Woolworths MarketPlus Seller Service Standards",
  },
  {
    href: "https://assets.mydeal.com.au/content/marketplace/Understanding%20GST%20and%20Invoice%20Impact%20for%20Sellers%20Not%20Registered%20for%20GST.pdf",
    text: "Understanding GST and Invoice Impact for Sellers Not Registered for GST",
  },
];

export const SellerPolicies = () => {
  return (
    <Section className={styles.bgWhitePadding}>
      <div className={styles.mb4AllP}>
        <Heading level={2} className={styles.heading2}>
          Woolworths MarketPlus Seller Policies
        </Heading>
        {sellerPolicyLinks.map((link) => (
          <p key={link.href}>
            <a href={link.href} className={styles.policyLink}>
              {link.text}
              <IconFileTypePdf
                size={18}
                stroke={1.8}
                className={styles.pdfIcon}
                aria-hidden="true"
              />
            </a>
          </p>
        ))}
      </div>
    </Section>
  );
};
